"use client";

import { useEffect } from "react";

import { ONE_SECOND_MS } from "#/config/time";
import { useUserScopes } from "#/services/dynamic/hooks/useUserScopes";
import { RFQRequestState, RFQResponseState } from "#/services/kyan/kyan.types";

import { useRfqRequests } from "./rfqRequests";
import { useRfqResponses } from "./rfqResponses";
import { useSelectedRfqRequest } from "./selectedRfqRequest";

export const RfqUpdater = () => {
  const { rfqRequests, setRfqRequests } = useRfqRequests();
  const { setRfqResponses } = useRfqResponses();
  const { setSelectedRfqRequest, selectedRfqRequest } = useSelectedRfqRequest();
  const { hasEarlyAccessVip } = useUserScopes();

  useEffect(() => {
    if (!hasEarlyAccessVip) {
      return;
    }

    const prune = () => {
      const now = Date.now();
      const filterRfq = <T extends { deadline?: number }>(state: T[]) => {
        const next = state.filter((r) => !(r.deadline && now > r.deadline));
        return next.length === state.length ? state : next;
      };

      setRfqRequests(filterRfq<RFQRequestState>);
      setRfqResponses((curr) => filterRfq<RFQResponseState>(curr));
    };

    prune();
    const id = window.setInterval(prune, ONE_SECOND_MS * 2);
    return () => window.clearInterval(id);
  }, [setRfqRequests, setRfqResponses, hasEarlyAccessVip]);

  useEffect(() => {
    if (
      !rfqRequests.some(
        (request) => request.orderId === selectedRfqRequest?.orderId,
      )
    ) {
      setSelectedRfqRequest(undefined);
    }
  }, [rfqRequests, selectedRfqRequest, setSelectedRfqRequest]);

  return null;
};
